// store/student/exam/store/_actionTypes.js

// Get available exams
export const GET_AVAILABLE_EXAMS_REQUEST = 'GET_AVAILABLE_EXAMS_REQUEST';
export const GET_AVAILABLE_EXAMS_SUCCESS = 'GET_AVAILABLE_EXAMS_SUCCESS';
export const GET_AVAILABLE_EXAMS_FAILURE = 'GET_AVAILABLE_EXAMS_FAILURE';

// Start exam
export const START_EXAM_REQUEST = 'START_EXAM_REQUEST';
export const START_EXAM_SUCCESS = 'START_EXAM_SUCCESS';
export const START_EXAM_FAILURE = 'START_EXAM_FAILURE';

// Save answer (auto-save)
export const SAVE_ANSWER_REQUEST = 'SAVE_ANSWER_REQUEST';
export const SAVE_ANSWER_SUCCESS = 'SAVE_ANSWER_SUCCESS';
export const SAVE_ANSWER_FAILURE = 'SAVE_ANSWER_FAILURE';

// Submit exam
export const SUBMIT_EXAM_REQUEST = 'SUBMIT_EXAM_REQUEST';
export const SUBMIT_EXAM_SUCCESS = 'SUBMIT_EXAM_SUCCESS';
export const SUBMIT_EXAM_FAILURE = 'SUBMIT_EXAM_FAILURE';

// Get exam results
export const GET_EXAM_RESULTS_REQUEST = 'GET_EXAM_RESULTS_REQUEST';
export const GET_EXAM_RESULTS_SUCCESS = 'GET_EXAM_RESULTS_SUCCESS';
export const GET_EXAM_RESULTS_FAILURE = 'GET_EXAM_RESULTS_FAILURE';

// Get exam history
export const GET_EXAM_HISTORY_REQUEST = 'GET_EXAM_HISTORY_REQUEST';
export const GET_EXAM_HISTORY_SUCCESS = 'GET_EXAM_HISTORY_SUCCESS';
export const GET_EXAM_HISTORY_FAILURE = 'GET_EXAM_HISTORY_FAILURE';

// Local state management
export const UPDATE_CURRENT_ANSWER = 'UPDATE_CURRENT_ANSWER';
export const SET_EXAM_TIMER = 'SET_EXAM_TIMER';
export const RESET_EXAM_STATE = 'RESET_EXAM_STATE';
export const SET_AUTO_SAVE_STATUS = 'SET_AUTO_SAVE_STATUS';